package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveWhiteboard
import fr.manyverse.app.domain.repository.WhiteboardRepository
import kotlinx.coroutines.flow.Flow

/**
 * Use case for observing active whiteboards targeted at a specific user.
 * Emits when a whiteboard is created or closed that targets this user.
 */
class ObserveActiveWhiteboardUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Observes active whiteboards for a specific user in a game table.
     * @param tableId The game table ID
     * @param currentUserId The user ID to filter whiteboards for
     * @return Flow emitting ActiveWhiteboard when the user is targeted, or null when closed
     */
    operator fun invoke(
        tableId: String,
        currentUserId: String
    ): Flow<ActiveWhiteboard?> {
        return whiteboardRepository.observeActiveWhiteboards(
            tableId = tableId,
            currentUserId = currentUserId
        )
    }
}
